import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/benefits/index.js'), 'benefits/index.js')
  resolveStoreModules(require('../store/banks/index.js'), 'banks/index.js')
  resolveStoreModules(require('../store/car/car.js'), 'car/car.js')
  resolveStoreModules(require('../store/catalog/catalog-cars.js'), 'catalog/catalog-cars.js')
  resolveStoreModules(require('../store/favorite/favorite.js'), 'favorite/favorite.js')
  resolveStoreModules(require('../store/features/features.js'), 'features/features.js')
  resolveStoreModules(require('../store/filters/filters.js'), 'filters/filters.js')
  resolveStoreModules(require('../store/folders/folders.js'), 'folders/folders.js')
  resolveStoreModules(require('../store/form/form-credit.js'), 'form/form-credit.js')
  resolveStoreModules(require('../store/form/form.js'), 'form/form.js')
  resolveStoreModules(require('../store/generations/generations.js'), 'generations/generations.js')
  resolveStoreModules(require('../store/header/header.js'), 'header/header.js')
  resolveStoreModules(require('../store/marks/marks.js'), 'marks/marks.js')
  resolveStoreModules(require('../store/modal/modal-callback.js'), 'modal/modal-callback.js')
  resolveStoreModules(require('../store/modal/modal-choose.js'), 'modal/modal-choose.js')
  resolveStoreModules(require('../store/modal/modal-credit.js'), 'modal/modal-credit.js')
  resolveStoreModules(require('../store/modal/modal-favorites.js'), 'modal/modal-favorites.js')
  resolveStoreModules(require('../store/modal/modal-main.js'), 'modal/modal-main.js')
  resolveStoreModules(require('../store/modal/modal-marks.js'), 'modal/modal-marks.js')
  resolveStoreModules(require('../store/modal/modal-menu.js'), 'modal/modal-menu.js')
  resolveStoreModules(require('../store/modal/modal-search.js'), 'modal/modal-search.js')
  resolveStoreModules(require('../store/reload/reload.js'), 'reload/reload.js')
  resolveStoreModules(require('../store/settings/settings.js'), 'settings/settings.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
